<template>

  <v-container>

    <v-overlay :value="loading">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-layout class="mb-2">

      <v-spacer></v-spacer>

      You are signed in as&nbsp;<strong>{{ $store.state.user.email }}</strong>&nbsp;<span v-if="$store.state.user.role != 'User'">({{ $store.state.user.role == 'Admin' ? 'Administrator' : $store.state.user.role }})</span>

    </v-layout>

    <v-dialog v-model="searchDialog" persistent max-width="1000">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Search</strong></v-card-title>

        <v-card-text class="text-body-1">

          <v-layout class="mt-4" wrap>

            <v-row>

              <v-col>

                <v-autocomplete label="Account (email)" v-model="searchFilter.accountEmail" maxlength="100" outlined :items="emails"></v-autocomplete>

              </v-col>

              <v-col>

                <v-autocomplete label="Changed By (email)" v-model="searchFilter.changedByEmail" maxlength="100" outlined :items="emails"></v-autocomplete>

              </v-col>

              <v-col>

                <v-autocomplete label="Object" v-model="searchFilter.object" maxlength="100" outlined :items="['Parcel', 'Registration', 'Owner', 'Operator', 'Order']"></v-autocomplete>

              </v-col>

            </v-row>

            <v-row>

              <v-col>

                <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                  <template v-slot:activator="{ on, attrs }">

                    <v-text-field v-model="searchFilter.dateChanged" label="Date Changed" hint="MM/DD/YYYY" maxlength="10" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="startDatePicker = parseDate(searchFilter.dateChanged)" v-on="on" outlined style="max-width: 175px"></v-text-field>

                  </template>

                  <v-date-picker v-model="startDatePicker" no-title @input="startDateMenu = false"></v-date-picker>

                </v-menu>

              </v-col>

              <v-col>

              </v-col>

              <v-col>

              </v-col>

            </v-row>

          </v-layout>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="searchDialog = false" color="primary">cancel</v-btn> <v-btn @click="search" color="primary">search</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-card elevation="0" class="pa-2">

      <v-card-title class="text-h5 word-break"><strong>Change Logs</strong></v-card-title>

      <v-card-text class="text-body-1">

        <div class="text-right">

          <v-btn color="primary" class="mb-4" @click="openSearchDialog"><v-icon left>mdi-magnify</v-icon>search</v-btn> <v-btn color="primary" class="mb-4" @click="reset">reset</v-btn>

        </div>

        <v-data-table :headers="headers" :items="changeLogs" class="elevation-1" sort-by="account" :sort-desc="true" :loading="loadingTable">

        </v-data-table>

      </v-card-text>

    </v-card>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";

export default Vue.extend({

  name: 'ChangeLogs',

  async created() {

    this.loading = true;

    setTimeout(async () => {

      try {

        let obj = await axios.get('accounts/get-user-info');

        var tokens = obj.data.split('\t');

        var email = tokens[1];

        var role = tokens[2];

        this.$store.dispatch('updateEmail', email);

        this.$store.dispatch('updateRole', role);

        let changeLogs = { data: null as any };

        let emails = await axios.get('api/ChangeLog/GetEmails');

        this.emails = emails.data;

        this.loading = false;

        this.changeLogs = changeLogs.data;
      }
      catch (error:any)
      {
        // there was an exception

        if (error.response && error.response.status == 401) {

          // the exception is "Unauthorized", redirect to login screen

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }
        else if (error.response && error.response.status == 404) {

          // the exception is "404 Not Found", redirect to 404 screen

          if (this.$route.path != '/NotFound') this.$router.push('/NotFound');

        }
        else {

          // all other exceptions

          this.clearSnackbars();

          this.snackbars.genericErrorText = 'There was an issue contacting the server.';

          this.snackbars.genericErrorSnackbar = true;

        }
      }

      this.loading = false;

    }, 200)

  },

  methods: {

    clearSnackbars() {

      this.snackbars.genericInfoSnackbar = false;

      this.snackbars.genericErrorSnackbar = false;

    },

    parseDate (date:any):any {

      if (!date) return null

      const [month, day, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

    },

    async reset() {

      this.searchFilter.accountEmail = '';

      this.searchFilter.object = '';

      this.searchFilter.changedByEmail = '';

      this.searchFilter.dateChanged = '';

      this.loading = true;

      setTimeout(async () => {

        let obj = { data: null as any };

        this.loading = false;

        this.changeLogs = obj.data;

      }, 200);

    },

    formatDate (date:any):any {

      if (!date) return null

      const [year, month, day] = date.split('-')

      return `${month}/${day}/${year}`

    },

    openSearchDialog()
    {
      this.searchDialog = true;
    },

    search() {

      this.searchDialog = false;

      this.loading = true;

      setTimeout(async () => {

        let obj = { data: null as any };

        this.loading = false;

        this.changeLogs = obj.data;

      }, 200);

    }

  },

  watch: {

    startDatePicker (val) {

      this.searchFilter.dateChanged = this.formatDate(this.startDatePicker)

    }

  },

  data () {

    return {

      snackbars: {

        errorSnackbar: false,

        genericErrorSnackbar: false,

        genericErrorText: '',

        genericInfoSnackbar: false,

        genericInfoText: '',

      },

      emails: [],

      startDateMenu: false,

      startDatePicker: '',

      searchDialog: false,

      searchFilter: {

        accountEmail: '',

        object: '',

        changedByEmail: '',

        dateChanged: ''

      },

      loading: false,

      loadingTable: false,

      changeLogs: [],

      headers: [

        { text: 'Account', value: 'account', class: 'primary white--text'},

        { text: 'Object', value: 'object', class: 'primary white--text' },

        { text: 'Property', value: 'property', class: 'primary white--text' },

        { text: 'Previous Value', value: 'previousValue', class: 'primary white--text' },

        { text: 'New Value', value: 'newValue', class: 'primary white--text' },

        { text: 'Changed By', value: 'changedBy', class: 'primary white--text' },

        { text: 'Date Created', value: 'dateCreated', class: 'primary white--text' }

      ],

    }

  }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

th > .v-icon {

  color: white !important;

}

th, td {

  font-size: 18px !important;

}

</style>
